import { DEMO_PRODUCTION, EMBED_DEMO } from 'constants/environment';
import { useEmbeddedProps } from 'hooks/useEmbeddedProps/useEmbeddedProps';

const useEnvironment = () => {
  const { env } = useEmbeddedProps();
  const environment = env === EMBED_DEMO ? DEMO_PRODUCTION : env;

  return { environment };
};

export { useEnvironment };
